































import { useStampStore } from '@/store/stamp';
import { computed, defineComponent } from '@vue/composition-api';
import { storeToRefs } from 'pinia';
import { useRoute } from '@/hooks/use-route';
import { biClick } from '@tencent/fit-bi-sdk';
import { isTencentCharity, getStampTitleList } from '@/config/tencent-charity';
import LoopAnnounce from '@tencent/wphk-components-loop-announce';

export default defineComponent({
  name: 'StampBalance',
  components: {
    LoopAnnounce,
   },
  setup() {
    const stampStore = useStampStore();
    const count = isTencentCharity() ? 14 : 7;
    const totalCount = new Array(count).fill('');

    console.log('是否是99公益日', isTencentCharity());

    const { userStampInfo } = storeToRefs(stampStore);

    const titles = getStampTitleList();

    const stampList = computed(() => totalCount.map((item, index) => {
      if (index < userStampInfo.value.intervalUsedCnt) {
        return 'used';
      }
      if (index < userStampInfo.value.intervalTotalCnt) {
        return 'got';
      }
      return '';
    }));

    const route = useRoute();
    const handleGoDetail = () => {
      if (!userStampInfo.value.usedCnt) return;
      route.router.push('/donation');
      biClick('stamp-balance.used_donate_click|累计捐赠点击');
    };
    return {
      titles,
      stampList,
      userStampInfo,
      totalCount,
      handleGoDetail,
    };
  },
});
